<template>
  <div>
    <b-row>
      <b-col
        cols="7"
        class="mb-1"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          :to="`/bridgelighting-sub?DeptID=${deptid}`"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /> <span style="color: #00FF80;"> ไฟประดับสะพาน: </span> {{ waydetail }}
        </b-link>
      </b-col>
      <b-col
        lg="5"
        md="5"
        sm="12"
        class="text-sm-right"
      >
        <!------------- status --------------->
        <b-button
          v-if="status === 0"
          class="mr-1"
          size="sm"
          variant="outline-success"
          style="cursor: context-menu; color:#fff;"
        >
          <span style="font-size: 14px;">สถานะการทำงาน: </span><span style="color:#fff; font-size: 16px;">ปิด</span>
        </b-button>
        <b-button
          v-if="status === 1"
          class="mr-1"
          size="sm"
          variant="outline-warning"
          style="cursor: context-menu;"
        >
          <span style="font-size: 14px;">สถานะการทำงาน: </span><span style="color:#fff; font-size: 16px;"> เปิด </span>
          <!-- <b-img
            src="@/assets/images/icons/dot1.gif"
            style="height: 10px; width: 30px;"
          /> -->
        </b-button>

        <span
          class="mr-1"
          style="font-size: 14px;"
        >สั่งงานระยะไกล:
          <b-button
            class="mr-1"
            size="sm"
            :variant="colorN"
            :disabled="disOn"
            @click="toggle(true)"
          >
            เปิด
          </b-button>
          <b-button
            size="sm"
            :variant="colorF"
            :disabled="disOff"
            @click="toggle(false)"
          >
            ปิด
          </b-button>
        </span>
        <!-- anydesk -->
        <a
          class="pull-right"
          :href="anydesk"
        >
          <b-button
            size="sm"
            variant="outline-danger"
          ><b-img
            src="@/assets/images/logo/anydesk.png"
            style="height: 16px; width: 16px;"
          /> <span style="color:#fff;"> {{ anydesk1 }}</span></b-button>
        </a>
      </b-col>
    </b-row>
    <modalLog
      ref="Log"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BLink, BButton, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import modalLog from './modalLog.vue'
/* eslint-disable global-require */
// import ModalStatusLighting from './ModalStatusLighting.vue'
// eslint-disable-next-line no-underscore-dangle

export default {
  components: {
    BRow,
    BCol,
    BLink,
    modalLog,
    BButton,
    BImg,
    // ModalStatusLighting,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      mode: '',
      status: '',
      vms_connect: '',
      anydesk: '',
      anydesk1: '',
      deptid: '',
      waydetail: '',
      operation: '',
      isActive: true,
      colorN: '',
      colorF: '',
      switch: {
        wid: this.$route.query.wid,
        send: '',
      },
      disOff: '',
      disOn: '',
    }
  },
  created() {
    this.getCenterSem()
  },
  mounted() {
    this.interval = setInterval(() => {
      // this.getCurrentTime()
      this.getCenterSem()
    }, 10000)
  },
  methods: {
    toggle(event) {
      // this.isActive = true
      if (event) {
        this.switch.send = '1'
        console.log(this.switch)
        this.$swal({
          title: '<span style="color:#000000">ต้องการเปิดไฟหรือไม่</span>',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง',
          reverseButtons: true,
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.value) {
            try {
              await axios.post('/openBridgeLighting', this.switch)
              if (this.isActive === true) {
                this.$swal({
                  icon: 'success',
                  title: '<span style="color:#000000">เปิดเรียบร้อยแล้ว</span>',
                  showConfirmButton: false,
                  timer: 1000,
                })
                this.colorN = 'success'
                this.colorF = 'secondary'
                this.disOn = true
                this.disOff = false
                this.getCenterSem()
              }
            } catch (error) {
              this.$swal({
                title: 'Error!',
                text: ' กดเพื่อดำเนินการต่อ!',
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }
          }
        })
      } else {
        // this.isActive = false
        this.switch.send = '2'
        this.$swal({
          title: '<span style="color:#000000">ต้องการปิดไฟหรือไม่</span>',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง',
          reverseButtons: true,
          customClass: {
            confirmButton: 'btn btn-primary ml-1',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.value) {
            try {
              await axios.post('/openBridgeLighting', this.switch)
              if (this.isActive === true) {
                this.$swal({
                  icon: 'success',
                  title: '<span style="color:#000000">ปิดเรียบร้อยแล้ว</span>',
                  showConfirmButton: false,
                  timer: 1000,
                })
                this.colorN = 'secondary'
                this.colorF = 'danger'
                this.disOn = false
                this.disOff = true
                this.getCenterSem()
              }
            } catch (error) {
              this.$swal({
                title: 'Error!',
                text: ' กดเพื่อดำเนินการต่อ!',
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }
          }
        })
      }
    },
    getCenterSem() {
      axios
        .post('/wayBridgeLightingDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.zoom = response.data[0].mapzoom
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.anydesk1 = response.data[0].anydesk
          this.anydesk = `anydesk:${response.data[0].anydesk}`
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.status = response.data[0].Light_status
          if (this.status === 1) {
            this.colorN = 'success'
            this.colorF = 'secondary'
            this.disOn = true
            this.disOff = false
          } else {
            this.colorN = 'secondary'
            this.colorF = 'danger'
            this.disOn = false
            this.disOff = true
          }
          this.plc = response.data[0].plc_cmd_send
        })
        .catch(error => {
          console.log(error)
        })
    },
    // getCurrentTime() {
    //   axios
    //     .post('/getPieTrafficDetail', { wid: this.$route.query.wid })
    //     .then(response => {
    //       this.mode = 'auto'
    //       // this.status = 'connecting'
    //       this.deptid = response.data[0].deptid
    //       this.waydetail = response.data[0].detail
    //       this.anydesk = 'anydesk:1111'
    //       // this.anydesk1 = '11111'
    //       this.operation = 'No'
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
  },
}
</script>

<style lang="scss">
</style>
